import * as Types from "../constants/User";


// FETCH PROFILE ACTIONS
export const fetchProfile = (id) => ({
  type: Types.FETCH_PROFILE,
  payload: id,
});

export const fetchProfileOk = (user) => ({
  type: Types.FETCH_PROFILE_OK,
  payload: user,
});

export const fetchProfileFailed = (error) => ({
  type: Types.FETCH_PROFILE_FAILED,
  payload: error,
});
